import React, {useEffect} from "react";
import { triggerWindowResize } from "utils/window-helpers";

export const useWindowResize = () => {
    useEffect(() => {
        triggerWindowResize();
    }, []);
};